var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlinkoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1374.2 276.1",
    enableBackground: "new 0 0 1374.2 276.1",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    enableBackground: "new    "
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#434DB8",
    d: "M355.992,102.692v28.995h57.991v28.995h-57.991v45.261h-37.482V73.697h103.252v28.995 C421.762,102.692,355.992,102.692,355.992,102.692z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#434DB8",
    d: "M441.564,73.697h37.482v131.54h-37.482V73.697z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#434DB8",
    d: "M563.91,170.584h-20.509v34.653h-37.482V73.697h60.112c36.067,0,58.698,18.387,58.698,48.797 c0,19.094-9.194,33.946-25.459,41.725l28.288,41.018h-39.603L563.91,170.584z M564.617,102.692h-20.509v38.189h20.509 c15.558,0,23.338-7.072,23.338-19.094C587.248,110.472,580.176,102.692,564.617,102.692z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#434DB8",
    d: "M752.733,176.242v28.995H647.36V73.697h103.252v28.995h-66.477v21.923h58.698v27.581h-58.698v24.045 H752.733z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#434DB8",
    d: "M812.138,102.692v28.995h57.991v28.995h-57.991v45.261h-37.482V73.697h103.252v28.995 C877.908,102.692,812.138,102.692,812.138,102.692z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#434DB8",
    d: "M897.002,73.697h37.482v101.837h62.941v29.703h-99.716V73.697H897.002z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#434DB8",
    d: "M1013.691,73.697h37.482v131.54h-37.482V73.697z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#434DB8",
    d: "M1203.928,73.697v131.54h-30.41l-57.991-70.013v70.013h-36.775V73.697h30.41l57.991,70.013V73.697H1203.928 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#434DB8",
    d: "M1282.428,157.854l-14.144,14.851v33.239h-36.775V73.697h36.775v54.455l50.918-54.455h41.018 l-53.747,57.991l56.576,73.549h-43.139L1282.428,157.854z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(1151.626 448.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    fill: "#434DB8",
    d: "M-1050.75-420.655c-3.536,2.122-6.365,3.536-9.194,4.951 c-10.608,5.658-20.509,10.608-31.117,16.266c-1.414,0.707-2.122,2.122-2.122,4.243c0,31.117,0,62.234,0,94.058 c0,40.311,0,79.914,0,120.224c0,2.829-0.707,4.951-3.536,5.658c-11.315,3.536-21.923,4.243-32.531-2.829 c-7.072-4.951-12.022-12.73-13.437-21.216c-2.829-11.315-1.414-23.338-2.122-34.653c-0.707-56.576-1.414-113.86-1.414-170.436 c-0.707-9.194,1.414-18.387,4.95-26.167c6.365-14.144,22.63-21.216,37.482-16.973c9.901,2.829,19.802,7.779,28.288,13.437 c7.779,4.243,15.558,8.487,22.63,12.73C-1052.164-422.069-1051.457-421.362-1050.75-420.655z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    fill: "#434DB8",
    d: "M-1049.335-202.837c0-1.414,0-2.122,0-3.536c0-19.095,0-38.189,0-57.991 c0-1.414,0.707-3.536,2.122-4.243c24.045-13.437,48.09-26.874,71.427-40.311c6.365-3.536,12.73-7.072,19.802-11.315 c-4.243-2.829-8.486-4.951-12.73-7.072c-10.608-6.365-21.216-12.023-31.824-18.387c-1.414-0.707-2.829-0.707-3.536,0 c-13.437,8.487-26.166,16.266-39.603,24.752c-0.707,0-0.707,0.707-1.414,0.707c0-1.414,0-2.122,0-3.536c0-14.144,0-28.288,0-41.725 c0-2.122,0.707-3.536,2.122-4.951c12.022-8.487,24.045-16.266,35.36-24.752c1.414-0.707,2.829-0.707,4.243,0 c16.266,9.194,33.238,19.095,49.504,28.288c11.315,6.365,22.63,12.73,34.653,19.095c8.486,4.243,15.558,11.315,20.509,19.802 c6.365,12.73,4.243,24.045-4.243,34.653c-5.658,6.365-12.73,12.023-19.802,15.559c-16.266,9.194-31.824,19.095-48.09,28.288 c-20.509,12.023-40.31,23.338-60.819,35.36C-1038.02-209.909-1043.678-206.373-1049.335-202.837z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlinkoLogo);
export default __webpack_public_path__ + "static/media/Flinko_Logo.688bebe82e5929049a398c47a350bacf.svg";
export { ForwardRef as ReactComponent };